import SummaryType from "state/selections/Constants/SummaryType";
import { Scan2Percentiles } from 'state/selections/Constants/PercentileOptions';
import { isDefined } from "@ls/js-utils";
import scope from './scope';

export default class Scan2Definition {
  static getDefault = () =>
    new Scan2Definition({
      scan2CalcType: 'PARAM',
      percentiles: Scan2Percentiles[0],
      summary: SummaryType.ABSOLUTE,
    });

  #summary;
  #scan2CalcType;
  #percentiles;


  constructor(props = {}) {
    const { scan2CalcType, percentiles, summary } = props;

    this.#scan2CalcType = scan2CalcType;
    this.#percentiles = percentiles;
    this.#summary = summary;
  }

  copy = () => {
    return {
      scan2CalcType: this.scan2CalcType,
      percentiles: this.percentiles,
      summary: this.summary,
    };
  };

  get scan2CalcType() {
    return this.#scan2CalcType;
  }
  get percentiles() {
    return this.#percentiles;
  }
  get summary() {
    return this.#summary;
  }
  get key() {
    return `${scope} -  ${this.#scan2CalcType}, ${this.#percentiles}, ${this.#summary}`;
  }
  get complete() {
    return isDefined(this.#scan2CalcType) && isDefined(this.#percentiles) && isDefined(this.#summary);
  }

  setScan2CalcType = (value) =>
    new Scan2Definition({
      ...this.copy(),
      scan2CalcType: value,
    });
  setPercentiles = (value) =>
    new Scan2Definition({
      ...this.copy(),
      percentiles: value,
    });
  setSummary = (value) =>
    new Scan2Definition({
      ...this.copy(),
      summary: value,
    });
}



